// Port of api/fuel/app/classes/insights/players/streaks.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function groupSequential(numbers) {
	var sorted = numbers.map(function(value) {
		return parseInt(value, 10)
	}).sort(function(a, b) { return a - b })
	var groups = []
	var current = []
	var last = null

	for (var i = 0; i < sorted.length; i++) {
		var n = sorted[i]
		if (last !== null && n === last + 1) current.push(n)
		else {
			if (current.length) groups.push(current)
			current = [n]
		}
		last = n
	}

	if (current.length) groups.push(current)
	return groups
}

function monthLabel(i) {
	var year = 1970 + Math.floor(parseInt(i, 10) / 12)
	var month = (parseInt(i, 10) % 12) + 1
	return Util.date('F Y', Util.mktime(0, 0, 0, [1, month, year]))
}

function dayLabel(i) {
	return Util.date('F jS Y', parseInt(i, 10) * Constants.TIME_DAY)
}

function weekStartTs(i) {
	return parseInt(i, 10) * Constants.TIME_WEEK
}

function weekEndTs(i) {
	return weekStartTs(i) + (6 * Constants.TIME_DAY)
}

function subtext(unit, startIndex, endIndex) {
	if (unit === 'year') return (startIndex === endIndex) ? String(startIndex) : (startIndex + ' - ' + endIndex)
	if (unit === 'month') {
		var a = monthLabel(startIndex)
		var b = monthLabel(endIndex)
		return (a === b) ? a : (a + ' - ' + b)
	}
	if (unit === 'week') {
		var start = Util.date('F Y', weekStartTs(startIndex))
		var end = Util.date('F Y', weekEndTs(endIndex))
		return (start === end) ? start : (start + ' - ' + end)
	}
	if (unit === 'day') {
		var dayA = dayLabel(startIndex)
		var dayB = dayLabel(endIndex)
		return (dayA === dayB) ? dayA : (dayA + ' - ' + dayB)
	}
	return ''
}

export default Segment.extend({
	name: 'streaks',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['streaks.period'],
	detail: ['streaks'],
	run: function(type, owner, userIndex, detail, filter) {
		var period = (filter && filter['streaks.period']) ? filter['streaks.period'] : 'year'
		var limit = detail ? 250 : 5
		var periodMap = {
			year: 'years',
			month: 'months',
			week: 'weeks',
			day: 'days'
		}
		var data = {
			streaks: [],
			total: 0
		}
		var streaks = []
		var players = this._data.players || []

		for (var i = 0; i < players.length; i++) {
			var playerStreaks = groupSequential(players[i][periodMap[period]] || [])
			for (var j = 0; j < playerStreaks.length; j++) {
				if (playerStreaks[j].length > 1) {
					streaks.push({
						count: playerStreaks[j].length,
						subtext: subtext(period, playerStreaks[j][0], playerStreaks[j][playerStreaks[j].length - 1]),
						id: parseInt(players[i].id, 10) || 0,
						slug: players[i].slug,
						name: players[i].primaryName,
						username: players[i].username
					})
				}
			}
		}

		data.total = streaks.length
		streaks = Util.sort_by_field(streaks, 'count', 'desc')
		if (streaks.length > limit) streaks = streaks.slice(0, limit)
		data.streaks = streaks

		return {
			streaks: data
		}
	}
})
